import React from 'react'
import Quick from "../components/EWallet1/QuickPay/merchantQuickPay/index"

const DashB = () => {
  return (
    <div>
     <Quick/>
    </div>
  )
}

export default DashB